import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { Gif } from '@giphy/react-components';
import { useMemo } from 'react';

import Button from '../Button';
import Image from '../Image';

import {
  actionClassName,
  buttonClassName,
  iconClassName,
  imageClassName,
  innerClassName,
  previewClassName,
} from './styles';
import { PreviewProps } from './types';

type Props = PreviewProps;

const Preview = ({ gif, image, onReset }: Props) => {
  const media = useMemo(() => {
    if (gif) {
      const { height, width } = gif['images']['original_still'];
      const multiplier = 160 / height;
      return (
        <Gif
          gif={gif}
          height={160}
          width={multiplier * width}
          hideAttribution={true}
          onGifClick={(_, e) => e.preventDefault()}
        />
      );
    } else if (image) {
      return <Image className={imageClassName} src={image} />;
    }
  }, [gif, image]);

  return (
    <div className={previewClassName}>
      <div className={innerClassName}>
        <div className={actionClassName}>
          <Button
            className={buttonClassName}
            faIcon={faTrashCan}
            iconClassName={iconClassName}
            onClick={onReset}
          />
        </div>
        {media}
      </div>
    </div>
  );
};

Preview.displayName = 'Preview';

export default Preview;
